// Define the types of styling for a row action, which can be an icon, the name of the action, or both.
export const ACTION_STYLE_TYPE = {
  ICON: 'icon',
  NAME: 'name',
};

export type TpActionStyle = (typeof ACTION_STYLE_TYPE)[keyof typeof ACTION_STYLE_TYPE];
export const ACTION_STYLES = Object.values(ACTION_STYLE_TYPE);

// Define the type of actions that can be performed, along with the default configuration for each action type.
export type TpActionConfig = {
  type: string;
  defaultPresentationType: TpActionStyle;
  presentation: {
    [key in TpActionStyle]: {
      icon: string | [string, string];
      label: string;
    };
  };
};

export const ACTION_CONFIGS: { [key: string]: TpActionConfig } = {
  OPEN_ASSET: {
    type: 'openAssetById',
    defaultPresentationType: ACTION_STYLE_TYPE.NAME,
    presentation: {
      [ACTION_STYLE_TYPE.NAME]: { icon: ['fas', 'chevron-right'], label: 'Open asset' },
      [ACTION_STYLE_TYPE.ICON]: { icon: ['fas', 'folder-open'], label: 'Open asset' },
    },
  },
} as const;

export type TpActionType = (typeof ACTION_CONFIGS)[keyof typeof ACTION_CONFIGS]['type'];
export const ACTION_TYPES = Object.values(ACTION_CONFIGS).map((action) => action.type);
export const getActionConfigByType = (type: string): TpActionConfig | undefined => {
  const actionConfig = Object.values(ACTION_CONFIGS).find((action) => action.type === type);
  if (!actionConfig) {
    console.warn(`Unknown data table action type "${type}"`);
    return undefined;
  }
  return actionConfig;
};

// Linked to the manifest defintion of the action configuration for a column in the data table
export interface TpColumnActionConfig {
  type: TpActionType;
  requiredProperty?: string;
  requiredPropertyValues?: string[];
  actionStyle?: TpActionStyle;
  actionIcon?: string;
  actionLabel?: string;
}

// Linked to the manifest definition of a column in the data table
export interface TpColumnConfig {
  id: string;
  width?: number;
  useBadge?: boolean;
  bold?: boolean;
  categoryColors?: { content: string; backgroundColor: { r: number; g: number; b: number } }[];
  numericalBar?: { minVal: number; maxVal: number };
  iconMapper?: { [categoryValue: string]: string | [string, string] };
  action?: TpColumnActionConfig;
}
